import * as reduxForm7 from 'redux-form';
export default reduxForm7;